import React from 'react';
import { WithDefaultLayout } from '@/components/DefautLayout';
import type { ReactElement, ReactNode } from 'react';
import BlogContent from '@/components/blog/BlogContent';

type NextPageWithLayout = React.FC & {
  layout?: (page: ReactElement) => ReactNode
}

const BlogPage: NextPageWithLayout = () => {
  return (
    <div className='w-full flex justify-center relative bg-gray-100 -mb-32 pb-5'>
      <div className="relative z-10 w-full flex justify-center">
        <BlogContent />
      </div>
      <img alt="" src='/images/CircleDots.svg' className='absolute top-96 left-16 z-0 pointer-events-none w-64 h-64 ' />

    </div>
  )
}

BlogPage.layout = WithDefaultLayout

export default BlogPage